export default {
  setFilter(state, { name, value }) {
    state.activeFilters = { ...state.activeFilters, [name]: value };
  },
  setItems(state, { value }) {
    state.items = value;
  },
  setReportTypes(state, { value }) {
    state.reportTypes = value;
  },
  setPagination(state, { value }) {
    state.pagination = value;
  },
  setLimit(state, { type, value }) {
    state[type].pagination.limit = value;
  },
  resetState(state) {
    state = {
      filtersSource: null,
      items: [],
      pagination: {
        limit: 24,
        offset: 0,
        countTotal: 0,
      },
    };
  },
};
